import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/")({
  component: AdminIndex,
});

// /admin lands on the role's default tab. Component-level (not beforeLoad):
// role isn't in router context, and RootLayout gates children until /auth/me
// resolves, so user is set by the time this renders.
function AdminIndex() {
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return (
    <Navigate to={user.role === "global_admin" ? "/admin/inbox" : "/admin/users"} replace />
  );
}
